module.exports = __webpack_public_path__ + "static/supagas-30b1cc71287326baf73b3c3a6590c3d2.jpg";